import { MobileWizard } from 'components/Wizards/MobileWizards/Layout'
import { multiStep } from 'components/Wizards/MobileWizards/MultiStepMobileWizard/multiStep'
import { StepProps } from 'components/Wizards/MobileWizards/MultiStepMobileWizard/Types'
import { ContentCard } from 'screens/blaze/Home/MobileHome/ContentCard/ContentCard'
import { useFormikContext } from 'formik'
import Styles from './SourceSelection.module.scss'

interface SourceSelectionProps extends StepProps {
  setSourceType?: (sourceType: string) => void
}

export const SourceSelection = multiStep<SourceSelectionProps>(
  ({ schema, submit, setSourceType }: SourceSelectionProps) => {
    const { meta } = schema.describe()
    const formik = useFormikContext<any>()

    const handleCardPress = (sourceType: string) => {
      setSourceType?.(sourceType)
      formik.setFieldValue('source_type', sourceType)
      submit()
    }

    return (
      <MobileWizard.Content>
        <MobileWizard.Section>
          <MobileWizard.Title>{meta.title}</MobileWizard.Title>
        </MobileWizard.Section>
        <MobileWizard.Section gap={0}>
          <ContentCard
            className={Styles.customCard}
            title="Video File"
            imgScale={1}
            imgSrc="https://res.cloudinary.com/almanac/image/upload/v1741201586/blaze_assets/mobile_home_and_create_new/create_new/turn-video-into_bfcrpi.png"
            textWidth="60%"
            onPress={() => handleCardPress('video')}
          />
          <ContentCard
            className={Styles.customCard}
            title="Audio File"
            imgScale={1}
            imgSrc="https://res.cloudinary.com/almanac/image/upload/v1741201586/blaze_assets/mobile_home_and_create_new/create_new/turn-audio-into.png"
            textWidth="60%"
            onPress={() => handleCardPress('audio')}
          />
          <ContentCard
            className={Styles.customCard}
            title="Website"
            imgSrc="https://res.cloudinary.com/almanac/image/upload/v1741201586/blaze_assets/mobile_home_and_create_new/create_new/turn-website.png"
            imgScale={1}
            textWidth="60%"
            onPress={() => handleCardPress('website')}
          />
          <ContentCard
            className={Styles.customCard}
            title="Blaze Document"
            imgSrc="https://res.cloudinary.com/almanac/image/upload/v1741201586/blaze_assets/mobile_home_and_create_new/create_new/turn-doc.png"
            imgScale={1}
            textWidth="60%"
            onPress={() => handleCardPress('document')}
          />
        </MobileWizard.Section>
      </MobileWizard.Content>
    )
  },
)
